import { graphql } from "@cappelendamm/crystallize-types/subscriptions/gql";
import Logger from "@cappelendamm/logger";
export const trackUsage = async ({ contractId, ...params }, { client }) => {
    Logger.log(`Tracking usage on contract ${contractId} in Crystallize:`, JSON.stringify(params));
    const data = await client.subscriptions.request(graphql(`
      mutation TrackUsage($id: ID!, $input: TrackUsageInput!) {
        subscriptionContracts {
          trackUsage(id: $id, input: $input) {
            id
          }
        }
      }
    `), { id: contractId, input: params });
    return data.subscriptionContracts.trackUsage.id;
};
